"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var class_1 = require("./class");
var options_1 = require("./options");
exports.options = options_1.default;
var configurable = true, enumerable = true, writable = true;
function createElementWraper(value, vm) {
    return {
        value: function (tag, data) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            if (data && '$style' in vm && !Array.isArray(data) && !class_1.isPrimitive(data))
                class_1.replaceClasses(vm, data);
            return value.call.apply(value, __spreadArrays([this, tag, data], args));
        },
        configurable: configurable,
        enumerable: enumerable,
        writable: writable
    };
}
function isImplicitModule(vm) {
    return vm && (options_1.default.unsafe || vm.$options && vm.$options.implicitCssModule);
}
function createPropertyDefinition(name) {
    return {
        set: function (value) {
            Object.defineProperty(this, name, isImplicitModule(this)
                ? createElementWraper(value, this)
                : {
                    value: value,
                    configurable: configurable,
                    enumerable: enumerable,
                    writable: writable
                });
        },
        configurable: true
    };
}
var _c = createPropertyDefinition('_c');
var $createElement = createPropertyDefinition('$createElement');
exports.default = {
    install: function (Vue, opts) {
        if (opts === void 0) { opts = {}; }
        if (!('FunctionalRenderContext' in Vue))
            throw new Error('Can not find FunctionalRenderContext. Unsupported Vue version.');
        if ('global' in opts && class_1.isObject(opts.global))
            options_1.default.global = opts.global;
        if ('unsafe' in opts && typeof opts.unsafe === 'boolean')
            options_1.default.unsafe = opts.unsafe;
        Object.defineProperties(Vue.prototype, { _c: _c, $createElement: $createElement });
        Object.defineProperties(Vue.FunctionalRenderContext.prototype, { _c: _c });
    }
};
//# sourceMappingURL=index.js.map